import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

class PageBreakBlot extends BlockEmbed {
  static blotName = 'pageBreak';
  static tagName = 'div'; // or use <div class="page-break"> for more control

  static create() {
    const node = super.create();
    node.setAttribute('class', 'page-break');
    return node;
  }
}

Quill.register(PageBreakBlot);
